import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import ProfileDetails from '../components/ProfileDetails';
import { selectLoadingProfileStatus, selectUserProfile } from '../../store/selectors/profile.selectors';
import OrganizationDetails from '../components/OrganizationDetails';

const ProfileViewPage = () => {
  const profile = useSelector(selectUserProfile);
  const isLoading = useSelector(selectLoadingProfileStatus);

  const history = useHistory();
  const { url } = useRouteMatch();

  const handleEdit = () => {
    history.push(`${url}/edit`);
  };

  return (
    <>
      <ProfileDetails
        user={profile}
        profile={profile}
        isLoading={isLoading}
        onEdit={handleEdit}
        onRemove={null}
      />
      <OrganizationDetails />
    </>
  );
};

export default ProfileViewPage;
